import { Scene } from '../types/obs';

interface LayoutCardProps {
  scene: Scene;
  resolution: { w: number; h: number };
  isActive: boolean;
  isVertical: boolean;
  onClick: () => void;
}

const SRC_COLORS = [
  'rgba(34,197,94,0.5)',
  'rgba(59,130,246,0.5)',
  'rgba(139,92,246,0.5)',
  'rgba(236,72,153,0.5)',
  'rgba(245,158,11,0.5)',
  'rgba(20,184,166,0.5)',
];

export function LayoutCard({ scene, isActive, isVertical, onClick }: LayoutCardProps) {
  const sourceCount = scene.sources.length;

  return (
    <div
      className={`layout-card ${isVertical ? 'vert-card' : ''} ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className={isVertical ? 'lthumb-vert' : 'lthumb-land'}>
        <div style={{ width: '100%', height: '100%', background: 'var(--bg-input)', position: 'relative' }}>
          {scene.sources.slice(0, 4).map((source, idx) => (
            <div
              key={source.id}
              style={{
                position: 'absolute',
                // positions/sizes are 0-1 percentages
                left: `${source.position.x * 100}%`,
                top: `${source.position.y * 100}%`,
                width: `${source.size.w * 100}%`,
                height: `${source.size.h * 100}%`,
                background: SRC_COLORS[idx % SRC_COLORS.length],
                borderRadius: '1px',
              }}
            />
          ))}
        </div>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="lname">{scene.name}</div>
        <div className="lsub">{sourceCount} source{sourceCount !== 1 ? 's' : ''}</div>
      </div>
    </div>
  );
}
